import { useEffect, useState } from "react";
import { useAppDispatch } from "store/hooks";
import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import useEventDataHook from "modules/event/hooks/useEventDataHook";
import { setCurrentEventId, setHasJoinedEvent } from "modules/event/eventSlice";
import CameraSettingsContainer from "modules/cameraSettings/CameraSettingsContainer";
import { PAGES, usePageTracking } from "modules/tracking";
import { WhiteLabelSettingsLoader } from "modules/settings/components/WhiteLabelSettingsLoader";
import { IEvent } from "modules/event/types";
import { EventActivityStatusListener } from "modules/eventActivityStatus/components/EventActivityStatusListener";
import { MicCamCheckView } from "./components";

const MicCamCheckContainer = () => {
  const dispatch = useAppDispatch();
  const { event: eventCode } = useQueryParams();
  const { getEventDataByCode } = useEventDataHook();
  const [loadedEvent, setLoadedEvent] = useState<IEvent | null>(null);

  useEffect(() => {
    if (!eventCode) return undefined;

    const asyncFunction = async () => {
      const event = await getEventDataByCode(eventCode as string);
      setLoadedEvent(event);
      if (!event) return;
      dispatch(setCurrentEventId(event.id));
      dispatch(setHasJoinedEvent(true));
    };
    asyncFunction();

    return () => {
      dispatch(setCurrentEventId(null));
      dispatch(setHasJoinedEvent(false));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventCode]);

  usePageTracking(PAGES.MIC_CAM_CHECK);

  return (
    <>
      <WhiteLabelSettingsLoader />
      <MicCamCheckView loadedEvent={loadedEvent} />
      <CameraSettingsContainer />
      <EventActivityStatusListener />
    </>
  );
};

export default MicCamCheckContainer;
